// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607170625/js/" + chunkId + "." + {"44":"a5287056","225":"3b375240","481":"71eec542","486":"1244714a","770":"2fdd2ec5"}[chunkId] + ".0.892131213314206.chunk.js";
};